<template>
  <chart-card :loading="loading" :title="$t('message.views.workbench.totalGmv')" :total="formatMoney(allGmvData.allGmv,3,'$')">
    <a-tooltip title="指标说明" slot="action">
      <a-icon type="info-circle-o" />
    </a-tooltip>
    <div>
      <a-row>
        <a-col :span="12">
          <trend :flag="getTrendFlag(allGmvData.dailyGmv - allGmvData.dailyGmvLastYear)" style="margin-right: 16px;">
            <span slot="term">{{ $t('message.views.workbench.wow') }}</span>
            {{Math.abs(Math.floor((allGmvData.dailyGmv - allGmvData.dailyGmvLastYear) / allGmvData.dailyGmvLastYear * 10000)) / 100}}%
          </trend>
        </a-col>
        <a-col>
          <trend :flag="getTrendFlag(allGmvData.weekGmv - allGmvData.weekGmvLastYear)">
            <span slot="term">{{ $t('message.views.workbench.dod') }}</span>
            {{Math.abs(Math.floor((allGmvData.weekGmv - allGmvData.weekGmvLastYear) / allGmvData.weekGmvLastYear * 10000)) / 100}}%
          </trend>
        </a-col>
      </a-row>
    </div>
    <template slot="footer">{{$t('message.views.workbench.dailyGmv')}}<span>{{formatMoney(allGmvData.dailyGmv,3,'$')}}</span></template>
  </chart-card>
</template>

<script>
import request from '../../../utils/request'
import formatMoney from '../../../utils/numberUtil'
import {
  ChartCard,
  MiniArea,
  Trend
} from '../../../components'
export default {
  name: 'AllGmv',
  components: {
    ChartCard,
    MiniArea,
    Trend
  },
  data () {
    return {
      allGmvData: {}
    }
  },
  mounted () {
    this.getAllGmv()
  },
  methods: {
    getAllGmv () {
      request({
        url: '/dashboard/gmv',
        method: 'get'
      }).then(response => {
        // response.data = json
        this.allGmvData = response.data.model
      })
    },
    getTrendFlag (value) {
      if (value > 0) {
        return 'up'
      } else if (value < 0) {
        return 'down'
      } else {
        return ''
      }
    },
    formatMoney
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Dashboard/components/AllGmv.vue